import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchHotels,
  setSelection,
  setView,
} from "../../../../../Redux/slice/features/hotelOccupancySlice";
import {
  fetchUserDetails,
  rehydrateAuthState,
} from "../../../../../Redux/slice/features/authSlice";
import AllHotelsMonthlyOccTable from "./AllHotelsMonthlyOccTable";
import HotelWiseMonthlyOccTable from "./HotelWiseMonthlyOccTable";
import HotelWiseMonthlyDetailTable from "./HotelWiseMonthlyDetailTable";

const HotelWiseMonthlyOccList = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { currentView, hotels, hotelId, year, loading } = useSelector(
    (state) => state.hotelOcc
  );

  const userHotelId = Number(user?.user?.PropertyID) || 0;
  const isManagerUser =
    user?.user?.Role === "Manager" ||
    user?.user?.role === "Manager" ||
    user?.user?.roleName === "Manager" ||
    user?.user?.user_role === "manager" ||
    user?.user?.role === "manager" ||
    (Array.isArray(user?.user?.roles) && user.user.roles.includes("Manager"));

  const isAdminUser =
    !isManagerUser &&
    (Number(user?.user?.customerId) === 1 ||
      user?.user?.UserName?.toString().toLowerCase() === "admin");

  const [selectedHotel, setSelectedHotel] = useState(
    userHotelId || hotelId || 0
  );
  const [selectedYear, setSelectedYear] = useState(year || new Date().getFullYear());

  useEffect(() => {
    dispatch(rehydrateAuthState());
    dispatch(fetchUserDetails());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchHotels(!isAdminUser && userHotelId ? userHotelId : null));
  }, [dispatch, isAdminUser, userHotelId]);

  useEffect(() => {
    if (!isAdminUser && userHotelId) {
      setSelectedHotel(userHotelId);
      dispatch(setSelection({ hotelId: userHotelId, year: selectedYear }));
      dispatch(setView("single"));
    }
  }, [dispatch, isAdminUser, selectedYear, userHotelId]);


  const yearOptions = [];
  for (let y = 2016; y <= 2040; y++) {
    yearOptions.push(y);
  }

  const handleFilterChange = () => {
    const hotelSelection = !isAdminUser && userHotelId ? userHotelId : selectedHotel;
    dispatch(setSelection({ hotelId: hotelSelection, year: selectedYear }));
    if (hotelSelection === 0) {
      dispatch(setView("all"));
    } else {
      dispatch(setView("single"));
    }
  };

  const handleBack = () => {
    if (currentView === "detail") {
      dispatch(setView("single"));
    } else if (currentView === "single" && isAdminUser) {
      dispatch(setView("all"));
    }
  };

  const effectiveView =
    currentView === "detail"
      ? "detail"
      : !isAdminUser && userHotelId
        ? "single"
        : currentView;

  return (
    <div className="container bg-white shadow-sm p-4 rounded">
      <h4 className="text-primary mb-4 border-bottom pb-2">
        Hotel Wise Monthly Occupancy
      </h4>

      <div className="row g-3 align-items-end bg-light p-3 rounded mb-4">
        <div className="col-md-4">
          <label className="form-label fw-bold">Hotel:</label>
          <select
            value={selectedHotel}
            onChange={(e) => setSelectedHotel(Number(e.target.value))}
            className="form-select"
            disabled={!isAdminUser && !!userHotelId}
          >
            {isAdminUser && <option value={0}>All Hotels</option>}
            {hotels.map((h) => (
              <option key={h.value} value={h.value}>
                {h.label}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-3">
          <label className="form-label fw-bold">Year:</label>
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(Number(e.target.value))}
            className="form-select"
          >
            {yearOptions.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-4 d-flex gap-2">
          <button
            onClick={handleFilterChange}
            disabled={loading}
            className="btn btn-primary"
          >
            {loading ? "Loading..." : "Apply"}
          </button>

          {(effectiveView === "detail" ||
            (effectiveView === "single" && isAdminUser)) && (
            <button
              className="btn btn-danger"
              onClick={handleBack}
            >
              <i className="fa fa-arrow-left me-2"></i> Back
            </button>
          )}
        </div>
      </div>

      {effectiveView === "all" && <AllHotelsMonthlyOccTable />}
      {effectiveView === "single" && <HotelWiseMonthlyOccTable />}
      {effectiveView === "detail" && <HotelWiseMonthlyDetailTable />}
    </div>
  );
};

export default HotelWiseMonthlyOccList;
